import BaseProxy from "../../base-proxy";
const TARGET_URL = "/companies";

/**
 * @class ApplyForManualPaymentProxy
 * @description Class used for communicating with applying for manual payment API.
 * @author Koh Keng Hong
 * @version 1.0
 * @since November 30, 2018
 */
export default class ApplyForManualPaymentProxy {
  /**
   * @async
   * @function execute
   * @param input - Input parameter instance.
   * @param data - Generic data parameter instance.
   * @param {String} input.expected_pay_at - Expected payment date.
   * @param {String} input.cheque_number - Cheque number (optional).
   * @param {String} data.authToken - Token used for issuing authenticated request.
   * @param {String} data.id - Company id.
   */
  async execute(data = {}, input = {}) {
    let baseProxy = new BaseProxy();
    let backendUrl = await baseProxy.getBackendUrl();
    let endpointUrl = `${backendUrl}${TARGET_URL}/${data.id}/apply-for-external-payment`;

    return await baseProxy.putAuthenticatedData(endpointUrl, data.authToken, input);
  }
}
